import { system } from './system-core.esm.js';

// port from @styled-system/background v.5.1.2

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var config = {};
config.background = true;
config.backgroundImage = true;
config.backgroundSize = true;
config.backgroundPosition = true;
config.backgroundRepeat = true;
config.bgImage = config.backgroundImage;
config.bgSize = config.backgroundSize;
config.bgPosition = config.backgroundPosition;
config.bgRepeat = config.backgroundRepeat;
var background = system(config);

export default background;
export { background };
//# sourceMappingURL=background.esm.js.map
